import { render, staticRenderFns } from "./Profesor.vue?vue&type=template&id=01a99bf9&scoped=true"
import script from "./Profesor.vue?vue&type=script&lang=js"
export * from "./Profesor.vue?vue&type=script&lang=js"
import style0 from "./Profesor.vue?vue&type=style&index=0&id=01a99bf9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a99bf9",
  null
  
)

export default component.exports